module.exports = __webpack_public_path__ + "static/img/120.26.168.136.6ee3e2ef.png";